'use strict';

import React from 'react'

import { PiFolderOpenThin } from 'react-icons/pi'

import { formatNum } from '@root/utility'

import { payment_types } from '@Config/options'

import bemit from '@function/bemit'

import BatchPaymentCheckStore from '@Store/BatchPaymentCheck'
import ModalsStore            from '@Store/Modals'

import { num } from '@root/utility'

const { moment } = window;

function onCbChange (e)
{
	const id = e.target?.getAttribute?.('data-id');

	if (!id) return;

	BatchPaymentCheckStore.update(function (store)
	{
		store[id] = e.target.checked === true;
	});
}

const DETAILS_MODAL = 'DepositDetails';

function openModal (e, id)
{
	ModalsStore.update(function (store)
	{
		store[DETAILS_MODAL] = { open: true, id: id, trg: e?.target };
	});
}

export default function PaymentRow ({ data, blank=true, fields, ...props })
{
	moment.locale('fr');

	const checked = BatchPaymentCheckStore.useState(s => s[data.id] === true);

	const cb_id = 'batch-check-' + data.id;

	const amount = data.payment_type !== 'credit_note'
	? num(data.amount)
	: Object.keys(data.amounts || { })
	.reduce((am, key) => num(am + num(data.amounts[key])), 0);

	return (
		<div className="c-dashboard__row">

			<div className="c-dashboard__cell Payment-date">
				{ moment(data.date).format('DD/MM/YYYY') }
			</div>

			<div className="c-dashboard__cell Payment-username">

				<div className="c-dashboard__long-text">
					{ data.name }
				</div>

			</div>

			<div className="c-dashboard__cell Payment-text_number">
				{ data.text_number }
			</div>

			<div className="c-dashboard__cell Payment-number">
				{ data.number }
			</div>

			<div className="c-dashboard__cell Payment-amount">
				{ formatNum(amount, '0,0[.]00') }
				€
			</div>

			<div className="c-dashboard__cell Payment-payment_type">
				{
					data.check_deposit
					? undefined
					: payment_types
					.find(opt => opt.value === data.payment_type)?.label
				}

				{
					data.check_deposit ?
					(
						<button type="button"
							onClick={ e => openModal(e, data.check_deposit) }
							className={ bemit('c-table-btn', ['in-cell', 'icon']) }>
							<PiFolderOpenThin className="c-table-btn__icon" />
							<span className="c-table-btn__label">bordereau</span>
						</button>
					)
					: undefined
				}

				{
					data.payment_type === 'check' && !data.check_deposit ?
					(
						<div className="c-form-element c-form-element--checkbox
							u-margin-top-0">
							<input className="c-form__checkbox"
								name={ cb_id }
								onChange={ onCbChange }
								id={ cb_id } type="checkbox"
								data-id={ data.id }
								checked={ checked }
							/>
							<label className="c-form__checkbox-indicator"
								htmlFor={ cb_id }
							/>
						</div>
					)
					: undefined
				}

			</div>

			<div className="c-dashboard__cell Payment-bills">
				{
					(data._bills || []).map(function (bill)
					{
						return bill?.order_number || bill?.text_number || '';
					})
					.join(', ')
				}

				{ data._credit_note?.text_number }
			</div>

		</div>
	);
}